import _ from 'lodash'
import { calculateExtraStatisticsFields } from './utils'

// Statistics by specific provider
export default class TotalDividedByProvider {
  constructor(rawStatistics, providerName) {
    this.rawStatistics = rawStatistics
    this.providerName = providerName
  }

  calculate() {
    const statistics = _.flatten(this.rawStatistics)
    const filteredStatistics = _.filter(
      statistics,
      (stat) => stat.providerName === this.providerName
    )
    const totalSpent = _.sumBy(filteredStatistics, 'spent')
    const totalImpressions = _.sumBy(filteredStatistics, 'impressions')
    const totalClicks = _.sumBy(filteredStatistics, 'clicks')
    const totalCounterImpressions = _.sumBy(filteredStatistics, 'counterImpressions')
    const totalGoals = _.sumBy(filteredStatistics, 'goals')

    return [
      calculateExtraStatisticsFields({
        providerName: this.providerName,
        spent: totalSpent,
        impressions: totalImpressions,
        clicks: totalClicks,
        counterImpressions: totalCounterImpressions,
        goals: totalGoals
      })
    ]
  }
}
